module.exports = __webpack_public_path__ + "static/img/FITmenu03.c8c6042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu03.png
// module id = ZVpp
// module chunks = 1